import {goBack} from '~/routing/actions'
import {LegacyFormModal, Message} from '~/components'
import {backend} from '@eitje/api'
import {useInvoicingStatus} from './use_invoicing_status'

export const PerformInvoicing = () => {
	const {startedAt, sentAt, status} = useInvoicingStatus()

	const invoicingMessage = [`modals.perform_invoicing.${status}_message`, {startedAt, sentAt}]

	return (
		<LegacyFormModal
			name="perform_invoicing"
			onSubmit={() => backend.post('billing_invoices/generate')}
			afterSubmit={goBack}
			modalProps={{
				t: 'modals.perform_invoicing.title',
				confirmSubmit: true,
				hideSubmit: !!startedAt,
				watch: startedAt,
				okButtonProps: {
					t: 'invoices.start_invoicing',
					iconLeft: 'paper-plane',
					confirmText: {t: 'modals.perform_invoicing.confirm_message'},
					confirmButtonProps: {t: 'invoices.start_invoicing', iconLeft: 'paper-plane'},
				},
			}}
			width={400}
		>
			<Message mdT={invoicingMessage} />
		</LegacyFormModal>
	)
}
